import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { createGlobalStyle } from 'styled-components';
import 'rxjs/add/operator/map';
import { messageSubscribe, messageUnsubscribe } from './windowMessageObservable';
import CheckboxFilterMenu from '../CheckboxFilterMenu';
import { Button, PageHeader, InteractionDetails, Pagination, Confirmation } from 'cx-ui-components';
import ReactTable from 'react-table';
import interactionIdColumn from '../../components/tableColumns/interactionId';
import queuesColumn from '../../components/tableColumns/queues';
import contactPointColumn from '../../components/tableColumns/contactPoint';
import customerColumn from '../../components/tableColumns/customer';
import channelColumn from '../../components/tableColumns/channel';
import directionColumn from '../../components/tableColumns/direction';
import startDateColumn from '../../components/tableColumns/startDate';
import startTimeColumn from '../../components/tableColumns/startTime';
import inQueueTimeColumn from '../../components/tableColumns/inQueueTime';
import elapsedTimeColumn from '../../components/tableColumns/elapsedTime';
import bulkColumn from '../../components/tableColumns/interactionManagement/bulk';
const InlineCheckboxFilterMenu = styled(CheckboxFilterMenu)`
  display: inline-block;
`;
const EndInteractionButton = styled(Button)`
  margin-right: 20px;
`;
const ConvertTimeButton = styled(Button)`
  margin-right: 20px;
`;

const Wrapper = styled.div`
  padding: 20px;
`;

const GlobalStyle = createGlobalStyle`
.InteractionManagementTable .rt-thead.-filters .rt-th {
  overflow: visible;
}
.InteractionManagementTable .rt-tbody {
  overflow-y: overlay;
  overflow-x: hidden;
}
.InteractionManagementTable .rt-resizer {
  z-index: 2 !important;
}
.InteractionManagementTable .rt-td:last-child {
  overflow: visible;
}
.InteractionManagementTable.has-monitored-interaction .-pagination {
  justify-content: flex-end;
}
`;

export default class InteractionManagement extends Component {
  constructor() {
    super();
    this.state = {
      defaultRowsNumber: parseFloat((window.innerHeight / 32 - 8).toFixed(0)),
      showEndInteractionPopup: false,
    };
    this.reactTable = React.createRef();
  }

  componentDidMount() {
    messageSubscribe();
    this.props.setCurrentEntity('interactionManagement');
    this.props.fetchData('queues', 'interactionManagement');
    this.props.startInteractionManagement();
  }
  componentWillUnmount() {
    messageUnsubscribe();
    //to clear selected bulk list on unmounting...
    this.props.onBulkClick('InteractionId', true, true);
  }

  defaultFilterMethod = ({ value, id }, row) =>
    String(row[id])
      .toLowerCase()
      .indexOf(value.toLowerCase()) > -1;

  highlightRow = ({ row }) => row.interactionId === this.props.monitoredId;

  getTableRowProps = (state, rowInfo) => {
    if (rowInfo) {
      return {
        onClick: () => {
          if (this.props.selected === rowInfo.row.interactionId) {
            return this.props.removeSelected();
          } else {
            return this.props.setSelected(rowInfo.row.interactionId, {
              [rowInfo.viewIndex]: rowInfo.row.interactionId,
            });
          }
        },
        style: {
          background: this.highlightRow(rowInfo) ? 'rgba(253, 255, 50, 0.17)' : null,
        },
      };
    } else {
      return { style: {} };
    }
  };

  getTdProps = () => ({ style: { fontSize: '11.5pt' } });
  getTheadProps = () => ({ style: { color: 'grey' } });
  onFilteredChange = (filtered) => this.setState({ filtered: filtered });
  onSortedChange = (sorted) => this.props.setSorted(sorted);
  SubComponent = ({
    row: {
      interactionId,
      queue,
      contactPoint,
      customerId,
      channel,
      direction,
      startDate,
      startTimestamp,
      inQueueTime,
      elapsedTime,
      customer,
      _original,
    },
  }) => {
    return (
      <InteractionDetails
        data={{
          interactionId,
          queue,
          contactPoint,
          customerId,
          channel,
          direction,
          startDate,
          startTimestamp,
          inQueueTime,
          elapsedTime,
          customer,
          flowName: _original.flowName,
          // InteractionManagement has no agent column so this replicates what the col does
          agentName: _original.agents.map(({ agentName }) => agentName).join(', '),
        }}
        twelveHourFormat={this.props.twelveHourFormat}
      />
    );
  };
  toggleTimeFormat = () => this.props.toggleTimeFormat();

  endInteractions = () => {
    this.setState({ showEndInteractionPopup: !this.state.showEndInteractionPopup });
  };

  handleEndInteraction = (e) => {
    const selectedInteractions = this.props.getBulkSelected;
    this.setState({ showEndInteractionPopup: !this.state.showEndInteractionPopup });
    selectedInteractions.forEach((interactionId) => {
      setTimeout(() => {
        this.props.endInteractions(interactionId);
      }, 1000);
    });
  };

  cancelEndInteraction = (e) => {
    this.setState({ showEndInteractionPopup: !this.state.showEndInteractionPopup });
  };

  selectToggle = (data, bool, visibleOrAll) => {
    for (let i = 0, len = data.length; i < len; i++) {
      let x = data[i];
      //interaction can be selected for multiple selection..
      this.props.onBulkClick(visibleOrAll === 'visible' ? x._original.interactionId : x.id, bool);
    }
  };

  getData = (visibleOrAll) => {
    const reactTable = this.reactTable.current;
    const pageIndex = reactTable.getResolvedState().page;
    const pageSize = reactTable.getResolvedState().pageSize;
    const startIndex = pageIndex > 0 ? pageSize * pageIndex : pageIndex;
    const endIndex = startIndex + pageSize;
    if (visibleOrAll === 'visible') {
      return reactTable.getResolvedState().sortedData.filter((x, index) => index >= startIndex && index < endIndex);
    } else {
      return reactTable.current.props.data;
    }
  };

  selectAllVisible = () => {
    this.selectToggle(this.getData('visible'), true, 'visible');
  };

  unselectAllVisible = () => {
    this.selectToggle(this.getData('visible'), false, 'visible');
  };

  render() {
    return (
      <Wrapper>
        <GlobalStyle/>
        <PageHeader text={this.props.pageTitle} helpLink={this.props.pageHelpLink}>
          <div>
            <EndInteractionButton
              id="endInteraction"
              disabled={
                this.props.tableData.toJS().length == 0 || this.props.getBulkSelected.toJS().length == 0 ? true : false
              }
              type="secondary"
              className="endInteraction"
              title={
                this.props.tableData.toJS().length !== 0 && this.props.getBulkSelected.toJS().length == 0
                  ? 'Please select interactions to delete'
                  : ''
              }
              onClick={this.endInteractions}>
              End Interaction
            </EndInteractionButton>

            {this.state.showEndInteractionPopup && (
              <Confirmation
                mainText="Notification"
                secondaryText="You have a selected Interactions to be terminated. Please confirm Yes Or No"
                openPopupBox={false}
                cancelBtnText="No"
                confirmBtnText="Yes"
                cancelBtnCallback={(e) => this.cancelEndInteraction(e)}
                confirmBtnCallback={(e) => this.handleEndInteraction(e)}
                onMaskClick={(e) => this.cancelEndInteraction(e)}
              />
            )}
            {/* <ConvertTimeButton
              id="timeConversion"
              type="secondary"
              className="timeConversion"
              onClick={this.toggleTimeFormat}>
              {this.props.twelveHourFormat ? '12h' : '24h'}
            </ConvertTimeButton> */}
            <InlineCheckboxFilterMenu
              type="secondary"
              menuType="Columns"
              tableType="interactionManagement"
              selectionType="checkbox">
              Columns
            </InlineCheckboxFilterMenu>
          </div>
        </PageHeader>

        <ReactTable
          PaginationComponent={Pagination}
          noDataText={'No interactions found'}
          ref={this.reactTable}
          defaultPageSize={this.state.defaultRowsNumber}
          pageSizeOptions={[this.state.defaultRowsNumber, 20, 50, 100]}
          className={`InteractionManagementTable -striped -highlight${
            this.props.monitoringStatus === 'connected' ? ' has-monitored-interaction' : ''
          }`}
          data={this.props.tableData.toJS()}
          filterable
          defaultFilterMethod={this.defaultFilterMethod}
          expanded={this.props.expanded}
          sorted={this.props.sorted}
          filtered={this.state.filtered}
          onFilteredChange={this.onFilteredChange}
          onSortedChange={this.onSortedChange}
          getTableProps={this.getTableProps}
          getTdProps={this.getTdProps}
          getTheadProps={this.getTheadProps}
          getTrProps={this.getTableRowProps}
          //SubComponent={this.SubComponent}
          columns={[
            bulkColumn('interactionManagement', this.props.onBulkClick, this.selectAllVisible, this.unselectAllVisible),
            interactionIdColumn(this.props.activeColumns[0]),
            queuesColumn(
              this.props.activeColumns[1],
              'interactionManagement',
              this.props.activeQueueFilters,
              this.props.queuesAreAllActive
            ),
            contactPointColumn(this.props.activeColumns[2]),
            customerColumn(this.props.activeColumns[3]),
            channelColumn(this.props.activeColumns[4]),
            directionColumn(this.props.activeColumns[5], 'interactionManagement'),
            startDateColumn(this.props.activeColumns[6], 'interactionManagement'),
            startTimeColumn(this.props.activeColumns[7], 'interactionManagement', this.props.twelveHourFormat),
            inQueueTimeColumn(this.props.activeColumns[8], 'interactionManagement'),
            elapsedTimeColumn(this.props.activeColumns[9], 'interactionManagement'),
          ]}
        />
      </Wrapper>
    );
  }
}

InteractionManagement.propTypes = {
  monitoredId: PropTypes.string,
  getCurrentAgentId: PropTypes.string,
  monitoringStatus: PropTypes.string,
  totalRatio: PropTypes.array,
  tableData: PropTypes.any,
  expanded: PropTypes.object.isRequired,
  selected: PropTypes.string.isRequired,
  areAllColNotActive: PropTypes.bool.isRequired,
  sorted: PropTypes.any.isRequired,
  toggleTimeFormat: PropTypes.func.isRequired,
  updateQueuesColumnFilter: PropTypes.func.isRequired,
  setExpanded: PropTypes.func.isRequired,
  setSelected: PropTypes.func.isRequired,
  setSorted: PropTypes.func.isRequired,
  removeSelected: PropTypes.func.isRequired,
  twelveHourFormat: PropTypes.bool.isRequired,
  activeColumns: PropTypes.arrayOf(PropTypes.bool.isRequired),
  setCurrentEntity: PropTypes.func,
  fetchData: PropTypes.func,
  startInteractionManagement: PropTypes.func,
  insideIframe: PropTypes.bool,
  pageTitle: PropTypes.string,
  pageHelpLink: PropTypes.string,
  loadingUserStatus: PropTypes.bool,
  activeQueueFilters: PropTypes.array,
  queuesAreAllActive: PropTypes.bool,
  onBulkClick: PropTypes.func,
};
